/* @flow */
export default {
  PNTimeOperation: 'PNTimeOperation',

  PNHistoryOperation: 'PNHistoryOperation',
  PNDeleteMessagesOperation: 'PNDeleteMessagesOperation',
  PNFetchMessagesOperation: 'PNFetchMessagesOperation',
  PNMessageCounts: 'PNMessageCountsOperation',

  // pubsub
  PNSubscribeOperation: 'PNSubscribeOperation',
  PNUnsubscribeOperation: 'PNUnsubscribeOperation',
  PNPublishOperation: 'PNPublishOperation',
  PNSignalOperation: 'PNSignalOperation',

  // Actions API
  PNAddMessageActionOperation: 'PNAddActionOperation',
  PNRemoveMessageActionOperation: 'PNRemoveMessageActionOperation',
  PNGetMessageActionsOperation: 'PNGetMessageActionsOperation',

  // Objects API
  PNCreateUserOperation: 'PNCreateUserOperation',
  PNUpdateUserOperation: 'PNUpdateUserOperation',
  PNDeleteUserOperation: 'PNDeleteUserOperation',
  PNGetUserOperation: 'PNGetUsersOperation',
  PNGetUsersOperation: 'PNGetUsersOperation',
  PNCreateSpaceOperation: 'PNCreateSpaceOperation',
  PNUpdateSpaceOperation: 'PNUpdateSpaceOperation',
  PNDeleteSpaceOperation: 'PNDeleteSpaceOperation',
  PNGetSpaceOperation: 'PNGetSpacesOperation',
  PNGetSpacesOperation: 'PNGetSpacesOperation',
  PNGetMembersOperation: 'PNGetMembersOperation',
  PNUpdateMembersOperation: 'PNUpdateMembersOperation',
  PNGetMembershipsOperation: 'PNGetMembershipsOperation',
  PNUpdateMembershipsOperation: 'PNUpdateMembershipsOperation',

  // File Upload API v1
  PNListFilesOperation: 'PNListFilesOperation',
  PNGenerateUploadUrlOperation: 'PNGenerateUploadUrlOperation',
  PNPublishFileOperation: 'PNPublishFileOperation',
  PNGetFileUrlOperation: 'PNGetFileUrlOperation',
  PNDownloadFileOperation: 'PNDownloadFileOperation',

  // Objects API v2
  //   UUID
  PNGetAllUUIDMetadataOperation: 'PNGetAllUUIDMetadataOperation',
  PNGetUUIDMetadataOperation: 'PNGetUUIDMetadataOperation',
  PNSetUUIDMetadataOperation: 'PNSetUUIDMetadataOperation',
  PNRemoveUUIDMetadataOperation: 'PNRemoveUUIDMetadataOperation',
  //   channel
  PNGetAllChannelMetadataOperation: 'PNGetAllChannelMetadataOperation',
  PNGetChannelMetadataOperation: 'PNGetChannelMetadataOperation',
  PNSetChannelMetadataOperation: 'PNSetChannelMetadataOperation',
  PNRemoveChannelMetadataOperation: 'PNRemoveChannelMetadataOperation',
  //   member
  // PNGetMembersOperation: 'PNGetMembersOperation',
  PNSetMembersOperation: 'PNSetMembersOperation',
  // PNGetMembershipsOperation: 'PNGetMembersOperation',
  PNSetMembershipsOperation: 'PNSetMembershipsOperation',

  // push
  PNPushNotificationEnabledChannelsOperation: 'PNPushNotificationEnabledChannelsOperation',
  PNRemoveAllPushNotificationsOperation: 'PNRemoveAllPushNotificationsOperation',
  //

  // presence
  PNWhereNowOperation: 'PNWhereNowOperation',
  PNSetStateOperation: 'PNSetStateOperation',
  PNHereNowOperation: 'PNHereNowOperation',
  PNGetStateOperation: 'PNGetStateOperation',
  PNHeartbeatOperation: 'PNHeartbeatOperation',
  //

  // channel group
  PNChannelGroupsOperation: 'PNChannelGroupsOperation',
  PNRemoveGroupOperation: 'PNRemoveGroupOperation',
  PNChannelsForGroupOperation: 'PNChannelsForGroupOperation',
  PNAddChannelsToGroupOperation: 'PNAddChannelsToGroupOperation',
  PNRemoveChannelsFromGroupOperation: 'PNRemoveChannelsFromGroupOperation',
  //

  // PAM
  PNAccessManagerGrant: 'PNAccessManagerGrant',
  PNAccessManagerGrantToken: 'PNAccessManagerGrantToken',
  PNAccessManagerAudit: 'PNAccessManagerAudit',
  PNAccessManagerRevokeToken: 'PNAccessManagerRevokeToken',
  //
};
